import { render, staticRenderFns } from "./EditTradePassword.vue?vue&type=template&id=f6d1b67e&scoped=true"
import script from "./EditTradePassword.vue?vue&type=script&lang=js"
export * from "./EditTradePassword.vue?vue&type=script&lang=js"
import style0 from "./EditTradePassword.vue?vue&type=style&index=0&id=f6d1b67e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d1b67e",
  null
  
)

export default component.exports